import React from "react";
import { playClick } from "@/lib/sound";

/**
 * CtaButton — primary action button with elegant glow + click sound.
 * Variants: "primary" (yellow), "dark" (midnight), "ghost" (outline on dark).
 */
export function CtaButton({
  children,
  onClick,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  size = "md",
  ...rest
}) {
  const handleClick = (e) => {
    if (disabled) return;
    playClick();
    if (onClick) onClick(e);
  };

  const sizes = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-5 py-2.5 text-sm",
    lg: "px-6 py-3 text-sm",
    xl: "px-8 py-4 text-base",
  };

  const variants = {
    primary:
      "bg-[#0A0C10] text-[#FBFAF7] hover:bg-black border border-black/0 cta-glow-dark",
    yellow:
      "bg-[#FFD600] text-[#0A0C10] cta-glow-yellow hover:brightness-105",
    mango:
      "bg-[#FFB400] text-[#0A0C10] cta-glow-mango hover:brightness-105",
    dark:
      "bg-[#0A0C10] text-white border border-white/10 cta-glow-blue hover:bg-[#11151E]",
    ghost:
      "bg-transparent text-[#0A0C10] border border-black/15 hover:border-black/60 hover:bg-black/5",
    danger:
      "bg-red-600 text-white cta-glow-red hover:brightness-110",
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`relative inline-flex items-center justify-center gap-2 font-semibold tracking-tight font-display
        transition-all duration-200 ease-out disabled:opacity-50 disabled:cursor-not-allowed
        active:translate-y-[1px] ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    >
      <span className="relative z-[1] inline-flex items-center gap-2">{children}</span>
    </button>
  );
}
